import { UPDATE_MODULES } from "../actionTypes";

const INITIAL_STATE = {};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_MODULES:
      return { ...state, ...action.payload.entities.modules };
    default:
      return state;
  }
};

export default reducer;
